import Immutable from "seamless-immutable";
import Api from "../lib/api";

export const SET_IMPORT_PIPELINE = "SET_IMPORT_PIPELINE";
export const SET_IMPORTS = "SET_IMPORTS";
export const SET_IMPORT = "SET_IMPORT";

export const startImportPipeline = (data) => {
  return async (dispatch) => {
    const importPipeline = await Api.startImportPipeLine(data);
    console.log("start import pipeline", importPipeline);
    dispatch({
      type: SET_IMPORT_PIPELINE,
      importPipeline,
    });
    return importPipeline;
  };
};

export const loadImports = ({
  type,
  perPage,
  page,
  sortBy,
  sortDirection,
  organizationId,
  workspaceId,
} = {}) => {
  return async (dispatch) => {
    let { imports, total } = await Api.getImports({
      type,
      perPage,
      page,
      sortBy,
      sortDirection,
      organizationId,
      workspaceId,
    });
    dispatch({
      type: SET_IMPORTS,
      imports,
      importsCount: total,
    });
  };
};

export const loadImport = ({ importId } = {}) => {
  return async (dispatch) => {
    const documentImport = await Api.getImport({
      importId,
    });
    dispatch({
      type: SET_IMPORT,
      documentImport,
    });
  };
};

export function getIntialState(state) {
  return Immutable({});
}

const initialState = Immutable({ importPipeline: null });

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IMPORT_PIPELINE:
      return state.set("importPipeline", action.importPipeline);
    case SET_IMPORT:
      return state.set("documentImport", action.documentImport);
    case SET_IMPORTS:
      return state
        .set("imports", action.imports)
        .set("importsCount", action.importsCount);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/actions/imports.js